import request from '@/utils/httpRequest'

export default class HandoverWithdrawalService {
    queryById(id) {
        return request({
            url: '/handover/wuyeHandoverWithdrawal/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/handover/wuyeHandoverWithdrawal/startFlow',
            method: 'post',
            data: params
        })
    }

}
